module.exports = __webpack_public_path__ + "img/bgi2.ec72e0a5.png";